export enum RegisterType {
  Personal = "personal",
  Corporate = "corporate",
}
